import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class ParticipantToParticipantInputBaseValueConverter {
    toView(array, configuration) {
        if (ObjectHelper.IsNullOrUndefined(array) || array.length <= 0) {
            return [];
        }
        return array.filter((item) => item['RoleId'] == configuration.roleId);
    }

}